module.exports = __webpack_public_path__ + "img/hiep.a7925f98.jpeg";